import { put, take } from 'redux-saga/effects';

import { GET_PAGE_BREAKS_SUCCESS } from 'PipeRouter';


function* getPageBreaksSuccess() {
  while(true) {
    yield take(GET_PAGE_BREAKS_SUCCESS);

    yield put({
      type: 'SHOW_PAGE_SELECTOR'
    });
  }
}


export default getPageBreaksSuccess;
